import React, {useState} from "react";
import Burger from '../Hamburger.js'
import MobileNavBar from '../MobileNavBar.js'
import '../Desktop.css'

import event1 from '../../Images/Illustration/YoGabbaGabba/EventPhoto1.jpg'
import event2 from '../../Images/Illustration/YoGabbaGabba/EventPhoto2.jpg'
import event3 from '../../Images/Illustration/YoGabbaGabba/EventPhoto3.jpg'
import event4 from '../../Images/Illustration/YoGabbaGabba/EventPhoto4.jpg'
import event5 from '../../Images/Illustration/YoGabbaGabba/EventPhoto5.jpg'
import event6 from '../../Images/Illustration/YoGabbaGabba/EventPhoto6.jpg'
import event7 from '../../Images/Illustration/YoGabbaGabba/EventPhoto7.jpg'

import postcard from '../../Images/Illustration/YoGabbaGabba/Postcard.jpg'
import postcardmock from '../../Images/Illustration/YoGabbaGabba/PostcardMockup.jpg'
import sketch1 from '../../Images/Illustration/YoGabbaGabba/Sketch1_color.jpg'
import sketch2 from '../../Images/Illustration/YoGabbaGabba/Sketch2_color.jpg'
import final from '../../Images/Illustration/YoGabbaGabba/FinalArt.jpg'


function YoGabbaGabba(){
	const [open, setOpen] = useState(false);

    return(
    	<div class="page">
			<div className="mobileNav">
				<Burger open={open} setOpen={setOpen}/>
				<MobileNavBar open={open} setOpen={setOpen}/>
			</div>
		    <div class="illustrationContentPage">
		        <h2>Yo Gabba Gabba Gallery Exhibition</h2>
		        <p class="contentText">
				Created a piece for an exhibition gallery featuring 50 artists reimagining characters from the show Yo Gabba Gabba. The exhibition was held at Brea Gallery in Los Angeles in 2025.		        
		        </p>
		        {/* <p class="contentText">Event:</p> */}
				<img class="contentImage" src={final} />
		        <img class="contentImage" src={event1} />
		        <img class="contentImage" src={event2} />
		        <img class="contentImage" src={event3} />
		        <img class="contentImage" src={event4} />
		        <img class="contentImage" src={event5} />
		        <img class="contentImage" src={event6} />
		        <img class="contentImage" src={event7} />

		        <img class="contentImage" src={postcard} />
		        <img class="contentImage" src={postcardmock} />
		        <img class="contentImage" src={sketch1} />
		        <img class="contentImage" src={sketch2} />

		    </div>
		</div>
    )
}

export default YoGabbaGabba